import './activity-log.scss';
import Header from '../../../organisms/header/header.js';
import RoleRibbonByRole from '../../../organisms/common/role-ribbon/role-ribbon-by-role';
import {Navigate, useLocation, useNavigate, useParams} from 'react-router-dom';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import decodeToken from '../../../../utils/decode-token';
import dayjs from 'dayjs';
import { fetchNotifications } from '../../../../api/hacApi';
import HacNavigation from "../../../organisms/common/hac-navigation/hac-navigation";
import { canAccessHacStaffArea, getHacBackPathForRole } from '../../../../utils/role-utils';
import BackButton from '../../../atoms/back-button';

function ActivityLog() {
  const {t} = useTranslation();
  const {hacId} = useParams();
  const token = sessionStorage.getItem('token') || null;
  const role = decodeToken(token).role;
  const navigate = useNavigate();

  const location = useLocation();
  const { breadcrumbName, backPath } = location.state || {};

  const [notifications, setNotifications] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    if (hacId) {
      const fetchData = async () => {
        try {
          const response = await fetchNotifications(token, hacId);
          if (response && (response.status === 200 || response.status === 204)) {
            setNotifications(response.data || null);
            setDataLoaded(true);
          }
        } catch (error) {
          console.error('Error al obtener notificaciones:', error);
        }
      };

      fetchData();
    }
  }, [hacId, token, t]);
  return (
    <>
      {token && canAccessHacStaffArea(role) ? (
        <div className="App">
          <Header />
          <RoleRibbonByRole role={role} navigate={navigate} translate={t} />
          <main>
            <section className="">
              <div className="inner menu">

                  <HacNavigation  />

                  <main className="profile activity-log">
                    <BackButton
                      fallbackTo={backPath || getHacBackPathForRole(role)}
                      context={breadcrumbName}
                    />

                    <h2>{t('activity-log-title')}</h2>
                    <p>{t('activity-log-text')}</p>

                    {dataLoaded ? (
                      notifications ? (
                        <div>
                          {notifications.map((notification) => {
                            const formattedDate = dayjs(
                              notification.timestamp
                            ).format('DD/MM/YYYY');
                            const formattedTime = dayjs(
                              notification.timestamp
                            ).format('HH:mm');

                            return (
                              <div
                                key={notification.id}
                                className="notification-item"
                              >
                                <header>
                                  <span className="text">
                                    {t(
                                      `activity-log-${notification.section}-${notification.operation}`
                                    )}
                                  </span>
                                  <span className="date">
                                    {formattedDate} - {formattedTime}
                                  </span>
                                </header>
                                <p>
                                  {notification.actor_name} -{' '}
                                  {t(`common-role-${notification.actor_role}`)}
                                </p>
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <strong>{t('activity-log-empty')}</strong>
                      )
                    ) : (
                      <p>{t('common-loading')}</p>
                    )}
                  </main>

              </div>
            </section>
          </main>
        </div>
      ) : (
        <Navigate to="/login" />
      )}
    </>
  );
}

export default ActivityLog;
